import React, {lazy, Suspense, useState} from 'react';
import MotionPage from './MotionPage';

class PageLoadBoundary extends React.Component {
  state = {error: null};

  static getDerivedStateFromError(error) {
    return {error};
  }

  componentDidCatch(error, info) {
    console.error('Unable to render page', error, info);
  }

  render() {
    if (this.state.error) {
      return <div role="alert" className="p-4">
        <p>This page could not be loaded.</p>
        <button type="button" className="btn btn-primary" onClick={this.props.onRetry}>
          Try again
        </button>
      </div>;
    }
    return this.props.children;
  }
}

export default function asyncComponent(importFunc) {
  let pending;
  const preload = () => {
    if (!pending) {
      pending = importFunc().catch(error => {
        pending = undefined;
        throw error;
      });
    }
    return pending;
  };
  let LazyComponent = lazy(preload);

  function WrappedLazyComponent(props) {
    const [attempt, setAttempt] = useState(0);
    const retry = () => {
      pending = undefined;
      // React.lazy caches rejected imports, so retries need a fresh lazy type.
      LazyComponent = lazy(preload);
      setAttempt(value => value + 1);
    };

    return (
      <PageLoadBoundary key={attempt} onRetry={retry}>
        <Suspense fallback={<div role="status" className="p-4">Loading page…</div>}>
          <MotionPage>
            <LazyComponent {...props} />
          </MotionPage>
        </Suspense>
      </PageLoadBoundary>
    );
  }
  WrappedLazyComponent.preload = preload;
  return WrappedLazyComponent;
}
